<mb-slider-base
  *ngIf="items"
  class="auto-height absolute-navigation"
  [items]="items"
  [itemsToSlide]="3"
  [itemsToShow]="3"
  [initialIndex]="initialIndex"
  #slider
  [config]="config"
  (indexChanged)="indexChanged.emit($event)"
>
  <ng-template #itemTemplate let-item="item" let-index="index" let-active="active">
    <ng-container *ngTemplateOutlet="itemTpl; context: { item: item, index: index, active: active }"></ng-container>
  </ng-template>
</mb-slider-base>
